module.exports = __webpack_public_path__ + "img/img36.585eda4a.svg";